module.exports = __webpack_public_path__ + "img/icon-notice-arrow-1fad7b89.svg";